import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { OracleResponsysDataset } from 'app/model/dataset/oracle-responsys.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleResponsysDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class OracleResponsysDatasetAdapter extends TabularTypeDatasetAdapter<OracleResponsysDataset, Model.DatasetResource> {
    protected async _toResource(dataset: OracleResponsysDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(OracleResponsysDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: OracleResponsysDataset): Promise<OracleResponsysDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, OracleResponsysDataset.MODEL);
    }
}
